import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from "@angular/core";
import { paths } from "src/app/Shared/enums/paths.enum";
import { CommonService } from "src/app/Shared/services/common_services/common.service";
import { NgbAccordion, NgbAccordionConfig } from "@ng-bootstrap/ng-bootstrap";
import { DataCommunicationService } from "src/app/Shared/services/data_service/data-communication.service";
import { LoaderindicatorService } from "src/app/Shared/services/loaderindicator/loaderindicator.service";
import { FormBuilder } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ReadingJsonService } from "src/app/Shared/services/configuration_service/reading-json.service";
import { OwlOptions } from 'ngx-owl-carousel-o/lib/models/owl-options.model';
import { ModalService } from "src/app/Shared/services";
import { async } from "@angular/core/testing";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";

declare var gtag;
@Component({
  selector: "app-car-service",
  templateUrl: "./car-service.component.html",
  styleUrls: ["./car-service.component.css"],
})
export class CarServiceComponent implements OnInit {
  // @ViewChild('acc', { static: false }) acc: NgbAccordion;
  @Output() recallComment = new EventEmitter<any>();
  maxNotesLength: number = environment.commentLength;
  selectgift:[];
  isRecallCollapsed = true;
  isServiceCollapsed = true;
  isEUCollapsed = true;
  isRepairCollapsed = true;
  isAccessoriesCollapsed = true;
  RadioSelection:boolean=false;
  RepairComment:string='';
  searchParams: any;
  completeserviceList = [];
  ServiceList = [];
  CategorywiseserviceList = [];
  activeIds: string[] = [];
  SelectedAdditionalService = [];
  SelectedRecallData =[];
  SelectedEUService = [];
  serviceCount = 0;
  selectedPackageName: any;
  selectedPackage: any;
  selectedPackageId: any;
  currentDate = new Date();
  CustomerNotes: string = '';
  brandName: string;
  year: any;
  licensePlate: any;
  Kelometer: any;
  IsSubmitted = true;
  panels = [];
  showServices = false;
  showScroll: boolean;
  visible: any;
  CompletePackageData = [];
  SelectedPackageData = [];
  PackagesServices = [];
  selected: any;
  packages = [];
  PackageDetail: any;
  FinalPackageServiceData: any;
  requiredservice = [];
  FinalPackageSelected = [];
  FinalServiceSelected = [];
  TotalPrice = 0;
  TotalDuration = 0;
  Duration = 0;
  InitialPackAgeData: any;
  showOLBService: Boolean = false;
  AdditionalServiceCount = 0;
  EUControlCount = 0;
  PackagesDetailed: any;
  packageListData: Array<any> = [];
  EUControlData: any;
  PackagesDetails: Array<any> = [];
  FinalAdditionalService = [];
  ServiceListData: Array<any> = [];
  FinalService: any;
  status: boolean;
  packagedetail = [];
  changedprice: any;
  selectindex: any;
  changedduration: any;
  MandatoryTotal = 0;
  AdditionalTotal = 0;
  AddDuration = 0;
  EUTotal = 0;
  EUDuration = 0;
  AdditionalTotalPrice = 0;
  PackagePrice = 0;
  PackageDuration = 0;
  PriceTotal = 0;
  DurationTotal = 0;
  AdditionalTotalDuration = 0;
  OLBServicePrice = 0;
  OLBServiceDuration = 0;
  OLBPrice = 0;
  OLBDuration = 0;
  BrandCode: any;
  BrandList: any;
  showPrice: boolean;
  PDetail;
  pkkDate: any;
  vinNo: any;
  VehilceKilometer;
  RequiredKM = false;
  showKilometer = 0;
  EUControlprice = 0; //1250;
  EUControlduration = 0;
  showEUControl = false;
  ModelImage: any;
  MthsFromRegistration: any;
  DateLastService: any;
  isShown: boolean = true;
  renaultFilePath = "../";
  subpackageList = [];
  FuelType: string;
  isDeadlineForPKK = false;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 2,
      },
      940: {
        items: 2,
      },
    },
    nav: true,
  };
  public scrollbarOptionss = { axis: "yx", theme: "minimal-dark" };
  modelPDF: any;
  pdfPath = "";
  SelectedDealerName: string='';
  AccessoriesList = [];
  accessoryTotalPrice: number = 0;
  giftCards = [];
  selectedGiftCards=[];
  showRecallDetails:boolean=false;
  recallDetail:any;
  urgent=[];
  service =[];
  optional=[];
  upSellData = [];
  mergedUpSellData: any[] = [];

  giftradio = [];
  dealerDetails: any;
  dealerConfig: any;
  workingCapacity: number = 0;
  constructor(
    public commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private loaderservice: LoaderindicatorService,
    protected readonly fb: FormBuilder,
    private translate: TranslateService,
    private readJsonFile: ReadingJsonService,
    private modalService: ModalService,
    config: NgbAccordionConfig,
    private sanitizer: DomSanitizer,
  ) {
    this.ModelImage =
      "data:image/jpeg;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
    // config.closeOthers = false;
    if (this.commonService.getLocalStorageitem("notes") != null) {
      this.CustomerNotes = this.commonService.getLocalStorageitem("notes");
    }
    this.commonService.removeLocalStorage(['SelectedService']);
  }
  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.HideAllPopup();
  }
  
  toggleShow() {
    // this.isShown = ! this.isShown;
    const MitsubishiParentClass = document.querySelector("#carService");
    if (MitsubishiParentClass.classList.contains("os-open")) {
      MitsubishiParentClass.classList.remove("os-open");
    } else {
      MitsubishiParentClass.classList.add("os-open");
    }
  }
  getGiftCardByPhone(){
    let phone = this.commonService.getLocalStorage('customerData').MobileNo;
    this.dataCommunicationService.GetGiftCardByPhone(phone).subscribe(resp =>{
      if(resp.StatusCode == 1 && resp.Data != null){
        let id = this.commonService.getLocalStorage('SelectedGiftCardId');
        this.giftCards = resp.Data.filter(x => x.LicensePlate === this.licensePlate);
        this.giftCards.forEach(x=>{
          x.isSelected = false;
        })
        if(id != null && id != 0){
          this.giftCards.find(x=>x.Id == id).isSelected=true;
          this.selectedGiftCards= this.giftCards.filter(x=>x.isSelected)
        }
        
      }
    })
  }

  selectGiftcard(item: any, event: any ){
    this.giftCards.find(x=>x.Id == item.Id).isSelected= event.target.checked;
    this.selectedGiftCards= this.giftCards.filter(x=>x.isSelected)
  }

  getAccessories(){
    this.AccessoriesList = [];
    let dealerId = this.commonService.getLocalStorage("dealername");
    dealerId = 5;
    this.dataCommunicationService.getAccessories(dealerId)
    .subscribe(response=>{
      if(response.StatusCode == 1){
        response.Data.forEach(element => {
          element.isSelected = false;
          element.ImagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + element.ImagePath);
        });
        this.AccessoriesList = response.Data;
      }
    });
  }
  GetUpSellData(){
    let brandCode = this.commonService.getLocalStorageByKey("vehicleData", "BrandCode");
    this.dataCommunicationService.GetUpSellData(brandCode).subscribe((result) => {
      if(result){
        this.upSellData = result;
      }
    });
  }

  // public getServiceList() {
  //   this.translate.get("LoaderText.services").subscribe((message) => {
  //     this.loaderservice.show(message);
  //   });
  //   this.searchParams = {
  //     BrandName: this.commonService.getLocalStorageByKey(
  //       "vehicleData",
  //       "BrandName"
  //     ),
  //     ModelName: this.commonService.getLocalStorageByKey(
  //       "vehicleData",
  //       "ModelName"
  //     ),
  //     Year: this.commonService.getLocalStorageByKey("vehicleData", "Year"),
  //   };
  //   this.dataCommunicationService
  //     .getVehicleServiceList(this.searchParams)
  //     .subscribe(
  //       (result) => {
  //         if (result.StatusCode === 1) {
  //           this.loaderservice.hide();
  //           this.completeserviceList = result.Data;
  //           this.completeserviceList.forEach(
  //             (x) => (x.LineAmountVat = x.TotalPrice)
  //           );
  //           this.filterServiceData();
  //         } else {
  //           this.translate
  //             .get("LoaderText.noServiceFound")
  //             .subscribe((message) => {
  //               this.loaderservice.show(message);
  //               this.loaderservice.hide();
  //             });
  //         }
  //       },
  //       (error) => {
  //         this.commonService.getErrorMessage("LoaderText.AlertMsg");
  //       }
  //     );
  // }

  public getPackageList() {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.searchParams = {
      licensePlate: this.licensePlate,
      VINNumber: this.vinNo,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehilceKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      IsOtherBrand: this.BrandList.MenuPricing === "WebCapri" ? false : true,
    };
    //this.searchParams = {licensePlate : this.licensePlate , dealerId :"031140", Kilometer : this.VehilceKilometer };
    this.dataCommunicationService.getAllPackages(this.searchParams).subscribe(
      (result) => {
        if (result.StatusCode === 1) {
          this.showOLBService = true;
          if (this.BrandCode == "Renault") 
            this.ShowPopup("openModelPDF");
          this.loaderservice.hide();
          this.PackagesDetailed = result.Data;
          this.packageListData.push(this.PackagesDetailed);
          if (this.BrandList.MenuPricing === "WebCapri") {
            this.EUControlData = this.PackagesDetailed.EUControlaServices;
            this.FinalAdditionalService = this.PackagesDetailed.AdditionalServices;
            this.FinalAdditionalService.forEach(element => {
              element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
            });
            this.EUControlData.forEach(element => {
              element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
            });
          }
          else if (this.BrandList.MenuPricing === "MPO") {
            this.getMPOAdditionalService();
          }

          this.getServiceChecked();

          this.ServiceListData = [];
          this.FinalService = [];
          this.packageListData.forEach(p=> {
            p.PackageDetail.forEach(pd => {
              pd.ServiceListData.forEach(pds => {
                pds.serviceTotal = Number(pds.serviceTotal.toFixed(0))
                this.ServiceListData.push(pds)
              });
            });
          })
          this.FinalService = this.ServiceListData;
          //this.FinalService[0].serviceTotal = 369.953
          //this.FinalService[1].serviceTotal = 131.235
          this.getPackageChecked();
          // if (this.packageListData.length > 0) {
          //   // tslint:disable-next-line: prefer-for-of
          //   for (var PD = 0; PD < this.packageListData.length; PD++) {
          //     if (this.packageListData[PD].PackageDetail.length > 0) {
          //       // tslint:disable-next-line: prefer-for-of
          //       for (var PDS = 0; PDS < this.packageListData[PD].PackageDetail.length; PDS++) {
          //         if (this.packageListData[PD].PackageDetail[PDS].ServiceListData.length > 0) {
          //           // tslint:disable-next-line: prefer-for-of
          //           for (var PDSD = 0; PDSD < this.packageListData[PD].PackageDetail[PDS].ServiceListData.length; PDSD++) {
          //             this.ServiceListData.push(
          //               this.packageListData[PD].PackageDetail[PDS]
          //                 .ServiceListData[PDSD]
          //             );
          //           }
          //         }
          //       }
          //     }
          //   }
          //   this.FinalService = this.ServiceListData;
          //   console.log(this.ServiceListData)
          //   this.getPackageChecked();
          // }
        } else {
          // this.translate.get('LoaderText.noServiceFound').subscribe(message => {
          //   this.loaderservice.show(message);
          //   this.loaderservice.hide();
          // });
        }
      },
      (error) => {
        this.commonService.getErrorMessage("LoaderText.AlertMsg");
        this.showOLBService = true;
        this.loaderservice.hide();
      }
    );
  }
  public computeDate(date) {
    date.setDate(
      date.getDate() + Number(this.dealerConfig.LeadTime));
    if (date.getDay() == 5) {
      date.setDate(date.getDate() + 3);
    } else if (date.getDay() == 6) {
      date.setDate(date.getDate() + 2);
    } else {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }
  public timeConvert(n) {
    const num = Number(n)
    if(num>0){
      return num/60;
    }
    return num;
    // const num = Number(n);
    // const hours = num / 60;
    // const rhours = Math.floor(hours);
    // const minutes = (hours - rhours) * 60;
    // const rminutes = Math.round(minutes);
    // if (rhours < 0) {
    //   return "0.0";
    // } else if(rhours==0)
    // {
    //   return hours;
    // }

    // return rhours + "." + rminutes;
  }
  public ConfirmService() {
    this.HidePopUp('upsellPopup');
    var pkkservice = false;
    this.commonService.removeLocalStorage([
      "waitingTime",
      "dropTime",
      "RentalCar",
      "kiosk",
      "AppointDate",
      "AvailableDates",
    ]);
    this.commonService.setLocalStorage("RepairComment",this.RepairComment);
    this.currentDate = this.computeDate(new Date());
    if (this.TotalDuration != 0 || this.AdditionalTotalDuration != 0 || this.EUControlduration != 0) {
      const duration = Number(this.TotalDuration) + Number(this.AdditionalTotalDuration) + Number(this.EUControlduration);
      if(duration > this.workingCapacity && !this.dealerConfig.IsAFXDealer){
        this.ShowPopup("longDuration");
        return 0;
      }
      this.commonService.setLocalStorage( "totalTime", this.timeConvert(duration));
    }
    else {
      this.commonService.setLocalStorage("totalTime",this.timeConvert(this.OLBDuration));
    }

    if (this.FinalPackageServiceData != null && this.FinalPackageServiceData.SelectedPackage.length > 0) {
      this.commonService.setLocalStorage("PackageServiceListData",this.FinalPackageServiceData);
    }
    if(this.SelectedAdditionalService != null && this.SelectedAdditionalService.length > 0){
      this.commonService.setLocalStorage("SelectedService", this.SelectedAdditionalService);
    }
    if(this.AccessoriesList != null && this.AccessoriesList.length>0){
      this.commonService.setLocalStorage("SelectedAccessories",this.AccessoriesList.filter(x => x['isSelected'] == true));
    }

    if (this.CustomerNotes !== undefined && this.CustomerNotes !== "" && this.CustomerNotes != null) {
      this.commonService.setLocalStorage("notes", this.CustomerNotes);
    }

    if (this.SelectedEUService != null && this.SelectedEUService.length > 0) {
      this.commonService.setLocalStorage("SelectedEUService",this.SelectedEUService);
      pkkservice = true;
    }
    // if (this.commonService.getLocalStorage("SelectedEUService")) {
    //   pkkservice = true;
    // }

    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });

    const appointmentCheckAvailabilityRequest: any = [];
    appointmentCheckAvailabilityRequest.TotalDuration = this.commonService.getLocalStorageitem("totalTime");
    appointmentCheckAvailabilityRequest.LicensePlate = this.commonService.getLocalStorageByKey("vehicleData","LicensePlateNo");
    appointmentCheckAvailabilityRequest.Make = this.commonService.getLocalStorageByKey("vehicleData","BrandName"),
    appointmentCheckAvailabilityRequest.PkkService = pkkservice;
    appointmentCheckAvailabilityRequest.DealerId = this.commonService.getLocalStorage("dealername");
    appointmentCheckAvailabilityRequest.StartDate = this.currentDate.getFullYear() + "-" +Number(this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate();

    if (
      this.commonService.getLocalStorageitem("waitingTime") != undefined &&
      this.commonService.getLocalStorageitem("waitingTime") != null &&
      this.commonService.getLocalStorageitem("waitingTime") != ""
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] = this.commonService.getLocalStorageitem("waitingTime");
    }
    else if (
      this.commonService.getLocalStorageitem("dropTime") != undefined &&
      this.commonService.getLocalStorageitem("dropTime") != null &&
      this.commonService.getLocalStorageitem("dropTime") != ""
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] = this.commonService.getLocalStorageitem("dropTime");
    }

    this.dataCommunicationService
      .checkAppointmentAvability(appointmentCheckAvailabilityRequest)
      .subscribe((result) => {
        // if (result.StatusCode === 1) {
        //   console.log(result.Data);
        // }
        //console.log('result', result)
        // this.commonService.setLocalStorage('unAvailableDates', result.Data.UnAvailableDates);
        // this.commonService.setLocalStorage('UnAvailableDatesForOccupied', result.Data.UnAvailableDatesForOccupied);
        // this.commonService.setLocalStorage('WeekDayList', result.Data.WeekDayList);
        this.commonService.setLocalStorage("AvailableDates",result.AvailableDates);
        if(this.selectedGiftCards != undefined)
        {
          this.commonService.setLocalStorage("selectedGiftCards",JSON.stringify(this.selectedGiftCards));
        }
        // if (this.SelectedEUService != null && this.SelectedEUService.length > 0) {
        //   this.commonService.setLocalStorage("SelectedEUService",this.SelectedEUService);
        // }
        this.PushDataToAnalytics(appointmentCheckAvailabilityRequest)
        this.commonService.NavigatePage(paths.CONFIRMBOOKING);
      },
      (error) => {
        this.loaderservice.hide(); 
        this.commonService.getErrorMessage("LoaderText.DMSDown");  
          
      });
    
  }

  public PushDataToAnalytics(appointmentData) {
    let currentData = {
      "so-totalDuration": appointmentData.TotalDuration+" hr",
      "so-isPkkService": appointmentData.PkkService,
      "so-mileage": this.VehilceKilometer,
      "so-isPromoCode": this.selectedGiftCards != undefined && this.selectedGiftCards.length > 0 ? true : false,
    };
    gtag('event', 'ServiceSelected', currentData);
  }
  // public filterServiceData() {
  //   this.panels = [];
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let i = 0; i < this.completeserviceList.length; i++) {
  //     if (
  //       !this.panels.some((x) => x === this.completeserviceList[i].CategoryName)
  //     ) {
  //       this.panels.push(this.completeserviceList[i].CategoryName);
  //       // add for active id and collapse
  //       this.activeIds = this.panels;
  //     }
  //   }
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let j = 0; j < this.panels.length; j++) {
  //     this.ServiceList = [];
  //     // tslint:disable-next-line:prefer-for-of
  //     for (let i = 0; i < this.completeserviceList.length; i++) {
  //       if (this.panels[j] === this.completeserviceList[i].CategoryName) {
  //         this.ServiceList.push(this.completeserviceList[i]);
  //       }
  //     }
  //     const finaldata = { data: this.ServiceList, panel: this.panels[j] };
  //     this.CategorywiseserviceList.push(finaldata);
  //     this.getServiceChecked();
  //   }
  // }

  public getCheckboxselected(serviceData) {
    // this.getServiceChecked();
    //to remove below comment in main application
    // if (this.SelectedAdditionalService.some(x => x.service === serviceData.ServiceId)) {
    if (
      this.SelectedAdditionalService.some((x) => x.ServiceId === serviceData.ServiceId)
    ) {
      return true;
    } else {
      return false;
    }
  }
  public getCheckboxselectedUpSell(serviceData) {
    return this.SelectedAdditionalService.some((x) => x.ServiceId === serviceData.ServiceId);
  }
  
  public getAdditionalServiceCheckedupSellData(con, event) {
    if (event.target.checked) {
      this.SelectedAdditionalService.push(con);
    } else {
      this.SelectedAdditionalService = this.SelectedAdditionalService.filter(
        (x) => x.ServiceId !== con.ServiceId
      );
    }
  }

  public getCheckboxselectedForRecall(serviceData) {
    // this.getServiceChecked();
    //to remove below comment in main application
    // if (this.SelectedAdditionalService.some(x => x.service === serviceData.ServiceId)) {
    if (
      this.SelectedRecallData.some((x) => x.ServiceId === serviceData.ServiceId)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public getEUCheckboxselected(euData) {
    if (this.SelectedEUService.some((x) => x.ServiceId === euData.ServiceId)) {
      return true;
    } else {
      return false;
    }
  }
  public getolbCheckboxselected(serviceData) {
    // this.getServiceChecked();
    //to remove below comment in main application
    // if (this.SelectedAdditionalService.some(x => x.service === serviceData.ServiceId)) {
    if (
      this.SelectedAdditionalService.some((x) => x.ServiceId === serviceData.ServiceId)
    ) {
      return true;
    } else {
      return false;
    }
  }
  public getServiceChecked() {
    if (this.commonService.getLocalStorageitem("SelectedEUService") != null) {
      this.SelectedEUService = this.commonService.getLocalStorage( "SelectedEUService" );
    }
    if (this.commonService.getLocalStorageitem("SelectedService") != null) {
      this.SelectedAdditionalService = this.commonService.getLocalStorage( "SelectedService" );

      this.IsSubmitted = false;
      this.serviceCount = this.SelectedAdditionalService.length;
      for (let i = 0; i < this.SelectedAdditionalService.length; i++) {
        this.OLBPrice = Number((this.OLBPrice + this.SelectedAdditionalService[i].TotalPrice).toFixed(2));
        this.OLBDuration = Number((this.OLBDuration + this.SelectedAdditionalService[i].Duration).toFixed(2));
      }
      for (let i = 0; i < this.SelectedAdditionalService.length; i++) {
        this.AdditionalTotal = Number((this.AdditionalTotal + this.SelectedAdditionalService[i].LineAmountVat).toFixed(2));
        this.AddDuration = Number((this.AddDuration + this.SelectedAdditionalService[i].duration).toFixed(2));
      }
      for (let i = 0; i < this.SelectedEUService.length; i++) {
        this.EUTotal = Number((this.EUTotal + this.SelectedEUService[i].LineAmountVat).toFixed(2));
        this.EUDuration = Number((this.EUDuration + this.SelectedEUService[i].duration).toFixed(2));
      }
      this.OLBServicePrice = this.OLBPrice;
      this.OLBServiceDuration = this.OLBDuration;
      this.AdditionalTotalPrice = this.AdditionalTotal;
      this.AdditionalTotalDuration = this.AddDuration;
      this.EUControlprice = this.EUTotal;
      this.EUControlduration = this.EUDuration;

      if (
        this.commonService.getLocalStorageitem("PackageServiceListData") != null
      ) {
        this.PriceTotal =
          this.EUControlprice +
          this.AdditionalTotalPrice +
          this.accessoryTotalPrice +
          Number(
            this.commonService
              .getLocalStorage("PackageServiceListData")
              ["TotalPrice"].toFixed(2)
          );
        this.DurationTotal =
          this.EUControlduration +
          this.AdditionalTotalDuration +
          Number(
            this.commonService
              .getLocalStorage("PackageServiceListData")
              ["TotalDuration"].toFixed(2)
          );
      } else {
        this.PriceTotal = this.accessoryTotalPrice + this.EUControlprice + this.AdditionalTotalPrice;
        this.DurationTotal =
          this.EUControlduration + this.AdditionalTotalDuration;
      }

      this.AdditionalServiceCount = this.SelectedAdditionalService.length;
      this.EUControlCount = this.SelectedEUService.length;
    }
  }

  public onAccessorySelecet(){
    this.PriceTotal -= this.accessoryTotalPrice;
    this.accessoryTotalPrice = 0;
    this.AccessoriesList.forEach(x => {
      this.accessoryTotalPrice += x['isSelected'] ? x['Price'] : 0;
    });
    this.PriceTotal += this.accessoryTotalPrice;
  }

  public NavigateVehicleList() {
    this.commonService.NavigatePage(paths.CARLIST);
  }
  public notesChange() {
    if (
      this.CustomerNotes !== undefined &&
      this.CustomerNotes !== "" &&
      this.CustomerNotes != null
    ) {
      this.commonService.setLocalStorage("notes", this.CustomerNotes);
    } else {
      this.commonService.removeLocalStorage(["notes"]);
    }
  }
  // public GetCssClass() {
  //   if (this.commonService.getLocalStorageByKey('vehicleData', 'BrandName') != 'Renault') {
  //     return 'ns-mg-renault'
  //   }
  //   else {
  //     return 'ns-mg-mitsubishi';
  //   }
  // }

  // public ReadJsonVehicleList() {
  //   this.readJsonFile.getJSONData().then((data) => {
  //     this.completeserviceList = data.ServiceMasters;
  //     this.commonService.setLocalStorage(
  //       "unAvailableDates",
  //       data.UnAvailableDates
  //     );
  //     this.commonService.setLocalStorage(
  //       "UnAvailableDatesForOccupied",
  //       data.UnAvailableDatesForOccupied
  //     );
  //     this.commonService.setLocalStorage("WeekDayList", data.WeekDayList);
  //     this.filterServiceData();
  //   });
  // }

  public ReadServiceFilePDF() {
    this.readJsonFile.getJSONFileData().then((data) => {
      //debugger;
      //console.log(data)
    });
  }
  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }
  ngOnInit() {
    this.SelectedDealerName = this.commonService.getLocalStorageitem("SelectedDealerName");
    this.ReadServiceFilePDF();
    this.dealerDetails = this.commonService.getLocalStorage('dealerDetails');
    this.BrandCode = this.commonService.getLocalStorageByKey("vehicleData","BrandName");
    this.brandName = this.BrandCode + " " + this.commonService.getLocalStorageByKey("vehicleData", "ModelName");
    this.licensePlate = this.commonService.getLocalStorageByKey("vehicleData","LicensePlateNo");
    this.vinNo = this.commonService.getLocalStorageByKey("vehicleData","VinNo");
    this.year = this.commonService.getLocalStorageByKey("vehicleData", "Year");
    this.MthsFromRegistration = this.commonService.getLocalStorageByKey("vehicleData","MthsFromRegistration");
    this.DateLastService = this.commonService.getLocalStorageByKey("vehicleData","DateLastService");
    if (this.DateLastService != "" &&this.DateLastService != undefined &&this.DateLastService != null) {
      this.DateLastService = this.commonService.formatDate(new Date(this.DateLastService));
    }
    var pkkdt = this.commonService.getLocalStorageByKey("vehicleData", "PKKDate");
    //console.log(pkkdt)
    //pkkdt = '2022-03-27T00:00:00'
    //console.log(pkkdt)
    this.pkkDate = this.commonService.formatDate(new Date(pkkdt));
    this.isDeadlineForPKK = this.monthDiff(new Date,new Date(pkkdt)) > 6 ? false : true;
    this.ModelImage = this.commonService.getLocalStorageByKey("vehicleData","ModelImage");
    this.FuelType = this.commonService.getLocalStorageByKey("vehicleData","Fuelcode"
    );
    this.commonService.removeLocalStorage([
      "serviceIDList",
      "PackageServiceListData",
      "SelectedService",
      "SelectedEUService",
      "SelectedAccessories"
    ]);
    const brand = this.brandName;
    const _brandName = brand.slice(0, 7);
    this.getFactoryRecall();
    this.getLocalStorageData();
    this.getModelPDF();
    //this.getAccessories();
    this.getGiftCardByPhone();
    //this.getPackagesData();
    this.getdealerConfigurationById(
      this.commonService.getLocalStorageitem("dealername")
    );
    //this.GetUpSellData();
  }

  getModelPDF() {
    let modelCode = this.commonService.getLocalStorageByKey("vehicleData","ModelCode");
    let brandCode = this.commonService.getLocalStorageByKey("vehicleData","BrandCode");
    if (brandCode.toLocaleLowerCase() == "renault") {
      this.dataCommunicationService.getModelPDF(modelCode, brandCode).subscribe((result) => {
        if (result.StatusCode == 1) {
          if (result.Data.ModelPDFPath != null && result.Data.ModelPDFPath != undefined && result.Data.ModelPDFPath != "") {
            this.modelPDF = "data:application/pdf;base64," + result.Data.ModelPDFPath;
          }
        }
      });
    }
  }
  //#region New Package-Service Code

  // public ReadJsonPackageData() {
  //   this.readJsonFile.getJSONData()
  //     .then(data => {
  //       this.CompletePackageData = data.ServicePackage;
  //       this.getPackageChecked();

  //     });
  // }
  getCSSDynamic() {   
    return this.commonService.getBrandTheme(this.BrandCode.toLocaleLowerCase());
  }
  public getMPOServices(URL, indexprice, packageID) {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.searchParams = {
      licensePlate: this.licensePlate,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehilceKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      Url: URL,
      IsDetailsService: true,
      IsOtherBrand: true,
      VINNumber: this.vinNo,
    };

    this.dataCommunicationService
      .getAllPackages(this.searchParams)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          this.loaderservice.hide();
          const listData = result.Data.PackageDetail[0].ServiceListData[0];
          const indexAt = this.FinalService.findIndex(
            (x) => x.PackageId == packageID
          );
          if (indexAt > -1) {
            this.FinalService[indexAt].PackageServiceList =
              listData.PackageServiceList;
            this.FinalService[indexAt].OptionalServiceDetailList =
              listData.OptionalServiceDetailList;
          }
          this.getPackagesDetails(this.FinalService[indexAt], packageID);
        }
      });
  }
  getPackage(packages: any, packageId) {
    if (this.BrandList.MenuPricing === "WebCapri") {
      //if(true){
      this.getPackagesDetails(packages, packageId);
    } else {
      if (packages == null || packages.PackageServiceList == null) {
        this.getMPOServices(packages.ServiceUrl, 0, packages.PackageId);
      } else {
        this.getPackagesDetails(packages, packageId);
      }
    }
  }

  getPackagesDetails(packages: any, packageId) {
    this.showPrice = false;
    //this.showServices = true;
    this.showServices = false;
    this.selectedPackageId = packageId;
    var otherCheckbox = true;

    this.commonService.removeLocalStorage(["PackageServiceListData"]);
    if (this.SelectedPackageData.length > 0) {
      if (
        this.SelectedPackageData.some((x) => x.PackageId === packages.PackageId)
      ) {
        if (this.BrandCode != "Renault") {
          this.SelectedPackageData = [];
        } else {
          const indexAt = this.SelectedPackageData.findIndex(
            (x) => x.PackageId === packages.PackageId
          );
          if (indexAt >= 0) {
            this.SelectedPackageData.splice(indexAt);
          } else {
            this.SelectedPackageData.push(packages);
            //this.getServicesOfPackages();
          }
        }
        otherCheckbox = false;
        // this.PackageSelection(false);
      } else {
        if (this.BrandCode != "Renault") {
          this.SelectedPackageData = [];
        }
        this.SelectedPackageData.push(packages);
        // this.getServicesOfPackages();
      }
    } else {
      this.SelectedPackageData = [];
      this.SelectedPackageData.push(packages);
      // this.getServicesOfPackages();
    }
    // earlier Code for Checkbox only
    // this.SelectedPackageData = [];
    // this.SelectedPackageData.push(packages);

    this.PackageSelection(otherCheckbox);
  }

  // getServicesOfPackages() {

  //   this.PackagesServices = [];
  //   this.PackagesServices = this.SelectedPackageData[0].PackageServiceList;
  //   this.requiredservice = this.PackagesServices;
  // // this.subpackageList= this.SelectedPackageData[0].subPackageList;
  //   // if (this.commonService.getLocalStorageitem('PackageServiceListData') != null) {
  //   //   var SelectedPackageData = this.commonService.getLocalStorage('PackageServiceListData')['SelectedPackage'];
  //   //   this.requiredservice = SelectedPackageData[0].SelectedPackageServices;
  //   // }
  // }

  PackageSelection($event) {
    this.serviceCount = 0;
    this.PriceTotal = 0;
    this.selectedPackageName = 0;
    this.TotalPrice = 0;
    this.TotalDuration = 0;
    this.PackageDetail = [];
    this.FinalService.forEach((x) => (x.selectedPrice = x.serviceTotal));
    if ($event == false) {
      this.FinalPackageServiceData = [];
      this.serviceCount = 0;
      this.selectedPackageName = "";
    }
    for (let k = 0; k < this.SelectedPackageData.length; k++) {
      this.PackageDetail.push({
        PackageId: this.SelectedPackageData[k].PackageId,
        packageName: this.SelectedPackageData[k].PackageName,
        price: this.SelectedPackageData[k].serviceTotal,
        selectedPrice: this.SelectedPackageData[k].serviceTotal,
        duration: this.SelectedPackageData[k].Duration,
        PackageType: this.SelectedPackageData[k].PackageType,
        PartsTotal: this.SelectedPackageData[k].PartsTotal,
        WorkTotal: this.SelectedPackageData[k].WorkTotal,
        VM: this.SelectedPackageData[k].VM,
        SelectedPackageServices: [],
        subPackageList: [],
      });
      this.requiredservice = this.SelectedPackageData[k].PackageServiceList;
      this.TotalPrice =
        Number(this.TotalPrice) +
        Number(this.SelectedPackageData[k].serviceTotal);
      for (let i = 0; i < this.requiredservice.length; i++) {
        // if (this.BrandList.MenuPricing == "WebCapri") {
        //   this.TotalPrice = Number((this.TotalPrice + this.requiredservice[i].LineAmountVat).toFixed(2));
        // }
        // else {

        //}
        if (this.requiredservice[i].ElementType == "1") {
          this.TotalDuration = Number(
            (this.TotalDuration + this.requiredservice[i].duration).toFixed(2)
          );
        }
      }
      this.PackageDetail[k].SelectedPackageServices = this.requiredservice;
      // this.PackageDetail[0].subPackageList=this.subpackageList;

      // if (this.commonService.getLocalStorageitem('PackageServiceListData') != null) {
      //   var PackageDetail = this.commonService.getLocalStorage('PackageServiceListData')['SelectedPackage'];
      //   var TotalPrice = this.commonService.getLocalStorage('PackageServiceListData')['TotalPrice'];
      //   var TotalDuration = this.commonService.getLocalStorage('PackageServiceListData')['TotalDuration'];

      //    this.FinalPackageServiceData = {
      //      SelectedPackage: PackageDetail,
      //      TotalPrice: TotalPrice,
      //      TotalDuration:TotalDuration

      //   };
      // }
    }

    this.FinalPackageServiceData = {
      SelectedPackage: this.PackageDetail,
      TotalPrice: this.TotalPrice,
      TotalDuration: this.TotalDuration,
    };

    if(this.FinalPackageServiceData.SelectedPackage.length > 0){
      this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
      this.selectedPackageName = this.FinalPackageServiceData.SelectedPackage[0].packageName;
    }

    if (this.SelectedPackageData.length > 0) {
      this.PriceTotal =
        this.FinalPackageServiceData.TotalPrice +
        this.AdditionalTotalPrice +
        this.accessoryTotalPrice +
        this.EUControlprice;
      this.DurationTotal =
        this.FinalPackageServiceData.TotalDuration +
        this.AdditionalTotalDuration +
        this.EUControlduration;
    } else {
      this.PriceTotal = this.accessoryTotalPrice + this.AdditionalTotalPrice;
      this.DurationTotal = this.AdditionalTotalDuration;
    }

    if (this.serviceCount > 0 || this.SelectedAdditionalService.length > 0 || this.SelectedEUService.length > 0) {
      this.IsSubmitted = false;
    } else {
      this.IsSubmitted = true;
    }
  }

  GetCheckedDetail(services) {
    if (this.requiredservice.some((x) => x.ServiceId === services.ServiceId)) {
      return true;
    } else {
      return false;
    }
  }
  public numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public getAdditionalServiceChecked(con, event) {
    return true;
    // let AdditionalTotal = 0;
    // if (event.target.checked === false) {
    //   const indexAt = serviceArray.findIndex(x => x.ServiceId === services.ServiceId);
    //   serviceArray.splice(indexAt, 1);
    //   this.TotalPrice = this.TotalPrice - services.LineAmountVat;
    // }
    // else{

    // }
  }
  // public PushselectedService(serviceData, $event) {
  //   this.IsSubmitted = true;
  //   // if(this.commonService.getLocalStorage('OLBServicePrice') != null){
  //   // this.OLBPrice =this.commonService.getLocalStorage('OLBServicePrice');
  //   // }
  //   if ($event.target.checked === false) {
  //     const indexAt = this.SelectedAdditionalService.findIndex(
  //       (x) => x.ServiceId === serviceData.ServiceId
  //     );
  //     this.SelectedAdditionalService.splice(indexAt, 1);
  //     this.OLBPrice = Number(
  //       (this.OLBPrice - serviceData.TotalPrice).toFixed(2)
  //     );
  //     this.OLBDuration = Number(
  //       (this.OLBDuration - serviceData.Duration).toFixed(2)
  //     );
  //   } else {
  //     if (this.SelectedAdditionalService.length === 0) {
  //       this.SelectedAdditionalService.push(serviceData);
  //       this.OLBPrice = Number(
  //         (this.OLBPrice + serviceData.TotalPrice).toFixed(2)
  //       );
  //       this.OLBDuration = Number(
  //         (this.OLBDuration + serviceData.Duration).toFixed(2)
  //       );
  //     } else {
  //       // tslint:disable-next-line:prefer-for-of
  //       for (let i = 0; i < this.serviceCount; i++) {
  //         const index = this.SelectedAdditionalService.findIndex(
  //           (x) => x.CategoryName === serviceData.CategoryName
  //         );
  //         if (index > -1) {
  //           this.SelectedAdditionalService.splice(index, 1);
  //           this.SelectedAdditionalService.push(serviceData);
  //           this.OLBPrice = Number(serviceData.TotalPrice.toFixed(2));
  //           this.OLBDuration = Number(serviceData.Duration.toFixed(2));
  //         } else {
  //           this.SelectedAdditionalService.push(serviceData);
  //           this.OLBPrice = Number(
  //             (this.OLBPrice + serviceData.TotalPrice).toFixed(2)
  //           );
  //         }
  //         this.OLBDuration = Number(
  //           (this.OLBDuration + serviceData.Duration).toFixed(2)
  //         );
  //       }
  //     }
  //   }

  //   this.OLBServicePrice = this.OLBPrice;
  //   this.OLBServiceDuration = this.OLBDuration;
  //   this.serviceCount = this.SelectedAdditionalService.length;
  //   if (this.SelectedAdditionalService.length > 0) {
  //     this.IsSubmitted = false;
  //   } else {
  //     this.IsSubmitted = true;
  //   }
  //   this.commonService.setLocalStorage("SelectedService", this.SelectedAdditionalService);
  //   //   this.commonService.setLocalStorage('OLBServicePrice', this.OLBServicePrice);
  // }

  public PushAdditionalService(serviceData, $event) {
    this.IsSubmitted = this.RadioSelection ? false : true;

    if (this.SelectedPackageData.length > 0) {
      this.PackagePrice = Number(
        this.FinalPackageServiceData.TotalPrice.toFixed(2)
      );
      this.PackageDuration = Number(
        this.FinalPackageServiceData.TotalDuration.toFixed(2)
      );
    } else {
      this.PackagePrice = 0;
      this.PackageDuration = 0;
    }

    if ($event.target.checked === false) {
      const indexAt = this.SelectedAdditionalService.findIndex(
        (x) => x.ServiceId === serviceData.ServiceId
      );
      this.SelectedAdditionalService.splice(indexAt, 1);
      this.AdditionalTotalPrice = Number((this.AdditionalTotalPrice 
                                  - (!this.commonService.isFreeService(this.BrandCode, serviceData.groupId) ? serviceData.LineAmountVat : 0)).toFixed(2));
      this.AdditionalTotalDuration = Number((this.AdditionalTotalDuration - serviceData.duration).toFixed(2));
    } else {
      // tslint:disable-next-line:prefer-for-of
      const index = this.SelectedAdditionalService.findIndex(
        (x) => x.ServiceId === serviceData.ServiceId
      );
      if (index > -1) {
        this.SelectedAdditionalService.splice(index, 1);
        // this.AdditionalTotal = this.AdditionalTotal - serviceData.LineAmountVat;
        //  this.AddDuration = this.AddDuration - serviceData.duration;
      } else {
        this.SelectedAdditionalService.push(serviceData);
        this.AdditionalTotalPrice = Number((this.AdditionalTotalPrice 
                                    + (!this.commonService.isFreeService(this.BrandCode, serviceData.groupId) ? serviceData.LineAmountVat : 0)).toFixed(2));
        this.AdditionalTotalDuration = Number((this.AdditionalTotalDuration + serviceData.duration).toFixed(2));
      }
    }
    this.AdditionalServiceCount = this.SelectedAdditionalService.length;

    //this.AdditionalTotalPrice = this.AdditionalTotal;
    this.PriceTotal = this.AdditionalTotalPrice + this.PackagePrice + this.accessoryTotalPrice + this.EUControlprice;

    //this.AdditionalTotalDuration = this.AddDuration;
    this.DurationTotal = this.AdditionalTotalDuration + this.PackageDuration + this.EUControlduration;

    if ( this.SelectedAdditionalService.length > 0 || 
      (this.FinalPackageServiceData.SelectedPackage.length > 0 && this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length > 0) 
      || this.SelectedEUService.length > 0 ) {
      this.IsSubmitted = false;
    } else {
      this.IsSubmitted = this.RadioSelection ? false : true;
    }
    //this.commonService.setLocalStorage("SelectedService", this.SelectedAdditionalService);
  }

  public PushEUService(EUData, $event) {
    if (this.SelectedPackageData.length > 0) {
      this.PackagePrice = Number(
        this.FinalPackageServiceData.TotalPrice.toFixed(2)
      );
      this.PackageDuration = Number(
        this.FinalPackageServiceData.TotalDuration.toFixed(2)
      );
    } else {
      this.PackagePrice = 0;
      this.PackageDuration = 0;
      this.IsSubmitted = true;
    }
    if ($event.target.checked === false) {
      const indexAt = this.SelectedEUService.findIndex(
        (x) => x.ServiceId === EUData.ServiceId
      );
      this.SelectedEUService.splice(indexAt, 1);
      this.EUTotal = Number((this.EUTotal - EUData.LineAmountVat).toFixed(2));
      this.EUDuration = Number((this.EUDuration - EUData.duration).toFixed(2));
    } else {
      const index = this.SelectedEUService.findIndex(
        (x) => x.ServiceId === EUData.ServiceId
      );
      if (index > -1) {
        this.SelectedEUService.splice(index, 1);
      } else {
        this.SelectedEUService.push(EUData);
        this.EUTotal = Number((this.EUTotal + EUData.LineAmountVat).toFixed(2));
        this.EUDuration = Number(
          (this.EUDuration + EUData.duration).toFixed(2)
        );
      }
    }
    this.EUControlCount = this.SelectedEUService.length;

    this.EUControlprice = this.EUTotal;
    this.PriceTotal =
      this.AdditionalTotalPrice + this.PackagePrice + this.accessoryTotalPrice + this.EUControlprice;

    this.EUControlduration = this.EUDuration;
    this.DurationTotal =
      this.AdditionalTotalDuration +
      this.PackageDuration +
      this.EUControlduration;

    if (this.SelectedAdditionalService.length > 0 || 
      (this.FinalPackageServiceData.SelectedPackage.length > 0 && this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length > 0) 
      || this.SelectedEUService.length > 0) {
      this.IsSubmitted = false;
    }
    else {
      this.IsSubmitted = true;
    }
    this.commonService.setLocalStorage(
      "SelectedEUService",
      this.SelectedEUService
    );
  }
  getcheckedServices(services, event) {
    this.serviceCount = 0;
    let serviceArray = JSON.parse(
      JSON.stringify(
        this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices
      )
    );
    if (event.target.checked === false) {
      if (serviceArray.length > 0) {
        const indexAt = serviceArray.findIndex(
          (x) => x.ServiceId === services.ServiceId
        );
        serviceArray.splice(indexAt, 1);
        this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices = serviceArray;
        this.FinalPackageServiceData.TotalPrice = Number(
          (
            this.FinalPackageServiceData.TotalPrice - services.LineAmountVat
          ).toFixed(2)
        );
        if (services.ElementType == "1") {
          this.FinalPackageServiceData.TotalDuration = Number(
            (
              this.FinalPackageServiceData.TotalDuration - services.duration
            ).toFixed(2)
          );
        }
        // this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
        // this.FinalService.filter(x => x.PackageId === this.PackageDetail[0].PackageId)[0].selectedPrice =
        // this.SelectedPackageData.filter(x => x.PackageId == this.PackageDetail[0].PackageId)[0].selectedPrice - services.LineAmountVat;
      }
    } else {
      serviceArray.push(services);
      this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices = serviceArray;

      this.FinalPackageServiceData.TotalPrice = Number(
        (
          this.FinalPackageServiceData.TotalPrice + services.LineAmountVat
        ).toFixed(2)
      );
      if (services.ElementType == "1") {
        this.FinalPackageServiceData.TotalDuration = Number(
          (
            this.FinalPackageServiceData.TotalDuration + services.duration
          ).toFixed(2)
        );
      }

      this.FinalService.filter(
        (x) => x.PackageId == this.PackageDetail[0].PackageId
      )[0].selectedPrice =
        this.SelectedPackageData.filter(
          (x) => x.PackageId == this.PackageDetail[0].PackageId
        )[0].selectedPrice + services.LineAmountVat;
    }

    this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
    this.TotalPrice = this.FinalPackageServiceData.TotalPrice;
    this.TotalDuration = this.FinalPackageServiceData.TotalDuration;
    // this.FinalPackageServiceData.TotalPrice = this.FinalPackageServiceData.TotalPrice;
    // this.FinalPackageServiceData.TotalDuration = this.FinalPackageServiceData.TotalDuration;
    this.PriceTotal =
      this.FinalPackageServiceData.TotalPrice +
      this.AdditionalTotalPrice +
      this.accessoryTotalPrice +
      this.EUControlprice;
    this.DurationTotal =
      this.FinalPackageServiceData.TotalDuration +
      this.AdditionalTotalDuration +
      this.EUControlduration;
  }

  getPackageCheckboxselected(packages: any) {
    if (
      this.SelectedPackageData.some((x) => x.PackageId === packages.PackageId)
    ) {
      return true;
    } else {
      return false;
    }
  }
  public getPackageChecked() {
    if (
      this.commonService.getLocalStorageitem("PackageServiceListData") != null
    ) {
      //this.showServices = true;
      this.showServices = false;
      this.showPrice = true;
      this.IsSubmitted = false;
      this.SelectedPackageData = this.commonService.getLocalStorage(
        "PackageServiceListData"
      )["SelectedPackage"];

      this.SelectedPackageData = this.FinalService.filter(
        (x) => x.PackageId == this.SelectedPackageData[0].PackageId
      );
      this.selectedPackageName = this.SelectedPackageData[0].PackageName;

      var PackageDetail = this.commonService.getLocalStorage(
        "PackageServiceListData"
      )["SelectedPackage"];
      var TotalPrice = this.commonService.getLocalStorage(
        "PackageServiceListData"
      )["TotalPrice"];
      var TotalDuration = this.commonService.getLocalStorage(
        "PackageServiceListData"
      )["TotalDuration"];

      this.FinalPackageServiceData = {
        SelectedPackage: PackageDetail,
        TotalPrice: TotalPrice,
        TotalDuration: TotalDuration,
      };
      this.selectedPackageId = this.FinalPackageServiceData.SelectedPackage[0].PackageId;
      this.TotalPrice = this.FinalPackageServiceData.TotalPrice;
      this.TotalDuration = this.FinalPackageServiceData.TotalDuration;
      var SelectedPackageServices = this.commonService.getLocalStorage(
        "PackageServiceListData"
      )["SelectedPackage"];
      this.requiredservice = SelectedPackageServices[0].SelectedPackageServices;
      if (this.BrandList.MenuPricing == "MPO") {
        this.SelectedPackageData[0].PackageServiceList = this.requiredservice;
      }

      // for(let i=0 ; i<this.requiredservice.length ; i++){
      //  this.FinalService.filter(x => x.PackageId == this.FinalPackageServiceData.SelectedPackage[0].PackageId)[0].selectedPrice =
      //  this.SelectedPackageData.filter(x => x.PackageId == this.FinalPackageServiceData.SelectedPackage[0].PackageId)[0].selectedPrice + this.requiredservice[i].LineAmountVat;
      // }

      this.PriceTotal =
        this.EUControlprice +
        this.AdditionalTotalPrice +
        this.accessoryTotalPrice +
        Number(
          this.commonService
            .getLocalStorage("PackageServiceListData")
            ["TotalPrice"].toFixed(2)
        );
    }
  }

  public getPackagesData() {
    this.FinalService = [];
    this.packageListData = [];
    this.ServiceListData = [];
    this.SelectedPackageData = [];
    this.SelectedAdditionalService = [];
    this.SelectedEUService = [];
    this.FinalAdditionalService = [];
    this.showOLBService = false;
    this.AdditionalTotalDuration = 0;
    this.PackageDuration = 0;
    this.EUControlduration = 0;
    this.TotalDuration = 0;
    this.PriceTotal = 0;
    this.EUControlprice = 0;
    this.AdditionalTotalPrice = 0;
    this.accessoryTotalPrice = 0;
    this.PriceTotal = 0;
    if(this.factoryRecallData){
      this.getCheckedFactory();
    }
    this.commonService.removeLocalStorage([
      "serviceIDList",
      "PackageServiceListData",
      "SelectedService",
      "SelectedEUService",
      "SelectedAccessories"
    ]);
    if ( this.VehilceKilometer != undefined && this.VehilceKilometer != "" && this.VehilceKilometer != null ) {
      this.commonService.setLocalStorage("VehileKm", this.VehilceKilometer);
      this.brandList();
    }else{
      this.RequiredKM = true;
    }
    // if (this.VehilceKilometer == undefined) {
    //   this.VehilceKilometer = 0;
      
    // }
    
  }

  public getdealerConfigurationById(param: any) {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService
      .getDealersConfigurationById(param)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          //this.loaderservice.hide();
          this.commonService.setLocalStorage("dealerConfig", result.Data);
          this.workingCapacity = result.Data.WorkingCapacity;
          this.dealerConfig = result.Data;
          // if (result.Data.EnableMenuPricing == false) {
          //   this.getServiceList()
          // }
          // else {
          // this.brandList(this.BrandCode);
          //}
        }
      });
  }

  public brandList(): void {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService
      .getBrandById(this.BrandCode)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          this.loaderservice.hide();
          this.BrandList = result.Data;
          this.getPackageList();
          // if (this.BrandList.MenuPricing === "MPO") {
          //   this.getMPOAdditionalService();
          // } else {
          //   //this.FinalAdditionalService = [];
          // }
          // remove comment if require
          // if (this.BrandList.MenuPricing == "WebCapri") {
          //   this.getPackageList();
          // }
          // else if (this.BrandList.MenuPricing == "MPO") {
          //   console.log("Data from MPO");
          // }
          // else {
          //   this.getServiceList();
          // }
        }
      });
  }

  public getMPOAdditionalService() {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.EUControlData = [];
    this.searchParams = {
      licensePlate: this.licensePlate,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehilceKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      PackageId: 0,
      IsDetailsService: true,
      IsOtherBrand: true,
      VINNumber: this.vinNo,
    };

    this.dataCommunicationService
      .getMPOAdditionalPackage(this.searchParams)
      .subscribe((result) => {
        //if (result.StatusCode === 1) {
        this.loaderservice.hide();
        this.FinalAdditionalService = result.AdditionalServices;
        this.FinalAdditionalService.forEach(element => {
          element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
        });
        //EU Control Service
        this.EUControlData = result.EUControlaServices;
        this.EUControlData.forEach(element => {
          element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
        });
        // }
      });
  }
    mergeMPOWithUpSellData() {
      if (this.upSellData && this.FinalAdditionalService) {
        this.mergedUpSellData = [];
        this.upSellData.forEach(x => {
          const temp = this.FinalAdditionalService.find( y => y.groupId === x.ServiceUpSellId);
          if(temp){

            const isServiceSelected = this.SelectedAdditionalService.some(
              selectedService => selectedService.ServiceId === temp.ServiceId
            );
            if(!isServiceSelected){
              this.mergedUpSellData.push(temp);
            }
          }
        })
      }
    }
    
  public getKilometer() {
    this.showKilometer = 0;
    if ( this.VehilceKilometer != undefined && this.VehilceKilometer != "" && this.VehilceKilometer != null ) {
      this.RequiredKM = false;
      this.showKilometer = this.VehilceKilometer;
    } else {
      this.RequiredKM = true;
    }
  }

  factoryRecallData =[];
  labourService:any;
  
  public getFactoryRecall() {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.searchParams = {
      licensePlate: this.licensePlate,
      VINNumber: this.vinNo,
      dealerId: this.commonService.getLocalStorage("dealername"),
      BrandName: this.commonService.getLocalStorageByKey("vehicleData","BrandName"),
      ModelName: this.commonService.getLocalStorageByKey("vehicleData","ModelName"),
      IsOtherBrand: this.checkBrand(),
    };
    //this.searchParams = {licensePlate : this.licensePlate , dealerId :"031140", Kilometer : this.VehilceKilometer };
    this.dataCommunicationService
      .GetRecallDetail(this.searchParams)
      .subscribe((result) => {       
        this.loaderservice.hide();
        if(typeof(result) === 'string'){
          this.recallDetail=result;
          if (result.toString().toLowerCase() == "yes") {
           // this.IsSubmitted=true;
            this.ShowPopup("phevmodal");
            this.commonService.setLocalStorage("RF",result.toString().toLowerCase());
          } else {
            this.HidePopUp("phevmodal");
            this.commonService.removeLocalStorage(["RF"]);
          }
        }else{
          this.ShowPopup("phevmodal");
          this.commonService.setLocalStorage("RF",result);
          this.factoryRecallData =result.AdditionalServices;
        // this.labourService=result.AdditionalServices.Labour.ServiceName
        this.getCheckedFactory();
        }
        this.checkRecallShow();
      });
      
  }

  getCheckedFactory() {
    const dummyEvent = {
      target: {
        checked: true
      }
    };
    this.optional = [];
    this.service = [];
    this.factoryRecallData.forEach(x => {
      // if (x.Obligatory == true && x.Kind== "Security") {
      //   this.IsSubmitted = false;
      //   this.urgent.push(x);
      //   console.log(x);
      //   this.labourService = x.Labour.ServiceName;
      //   this.PushAdditionalService(x,dummyEvent);
      // } else
       if (x.Obligatory == true && x.Kind== "Quality") {
        this.IsSubmitted = false;
        this.service.push(x);
      //  this.service.push(x.Labour[0].ServiceName);
        this.PushAdditionalService(x,dummyEvent);
      } else {
        this.optional.push(x);
      }
    });
    this.loaderservice.hide();
    
  }
  public triggerUpsellPopup() {
    this.ShowPopup('upsellPopup');
  }

  isModalOpen = false;
  public HidePopUp(id) {
    this.isModalOpen = false;
    this.modalService.close(id);
  }

  public HideAllPopup(){
    this.HidePopUp("phevmodal");
    this.HidePopUp("longDuration");
    this.HidePopUp("callmemodal");
    this.HidePopUp("openModelPDF");
    this.HidePopUp("servicemodal");
    this.HidePopUp("workshop");
    this.HidePopUp("promocodeModal");
    this.HidePopUp("upsellPopup");
    this.HidePopUp("HongqiServiceText");
  }
  public ShowPopup(id) {
    this.isModalOpen = true;
    if (id === 'upsellPopup') {
      this.mergeMPOWithUpSellData();
      if(this.mergedUpSellData.length > 0){
        this.modalService.open(id);
      }
      else{
        this.ConfirmService();
      }      
    }
    else if(id == "openModelPDF"){
      if(this.BrandCode == "Renault" && this.modelPDF != undefined && this.modelPDF != null && this.modelPDF != '')
        this.modalService.open(id);
    }
    else
      this.modalService.open(id);
    // if (!(id == "openModelPDF" && this.BrandCode == "Mitsubishi"))
    //   this.modalService.open(id);
  }
  checkBrand() {
    if (this.brandName.toLocaleLowerCase().includes("renault")) {
      return true;
    } else if (this.brandName.toLocaleLowerCase().includes("dacia")) {
      return true;
    } else {
      return false;
    }
  }
  public getLocalStorageData() {
    this.VehilceKilometer = this.commonService.getLocalStorage('VehileKm');
    // if (this.VehilceKilometer != null && this.VehilceKilometer != undefined && this.VehilceKilometer != 0 && this.VehilceKilometer != '') {
    //   this.getPackagesData();
    // }
  }

  showPDFData(pack) {
    this.pdfPath = "";
    if (this.BrandCode.toLocaleLowerCase() == "mitsubishi") {
      if (pack.PackageName.toLocaleLowerCase().includes("5+"))
        this.pdfPath = "../../../assets/ServiceCheckList/Mitsubishi5PlusService.pdf";
      else
        this.pdfPath = "../../../assets/ServiceCheckList/Mitsubishi Example serivce checklist.pdf";
      this.ShowPopup("servicemodal");
    }
    else if(this.BrandCode.toLocaleLowerCase() == "renault") {
      if (pack.PackageName.toLocaleLowerCase().includes("service")) {
        if ( this.FuelType != null && this.FuelType != undefined && this.FuelType.toLocaleLowerCase() == "electric" )
          this.pdfPath = "../../../assets/ServiceCheckList/Serviceskjema_04 Renault EL.pdf";
        else
          this.pdfPath = "../../../assets/ServiceCheckList/Serviceskjema_03 Renault ICE.pdf";
      } 
      else
        this.pdfPath = "../../../assets/ServiceCheckList/OLB mersalgsprodukter.pdf";
      this.ShowPopup("servicemodal");
    }else if(this.BrandCode.toLocaleLowerCase() == "hongqi"){
      this.pdfPath = "../../../assets/ServiceCheckList/Nodvendigheten av vedlikehold Hongqi.pdf";
      this.ShowPopup("servicemodal");
    }
    
  }


  checkRecallShow(){
    if(typeof(this.recallDetail) === 'string'){
        this.showRecallDetails=false;
    }
    else{
      this.showRecallDetails=true;
    }
  }

  getRepairSelected(){
    this.removeRepairItem()
    if(this.RadioSelection && this.RepairComment){
      this.pushRepairData();         
    }else{
      this.RepairComment=null;
      this.IsSubmitted= (this.SelectedAdditionalService.length > 0) || (this.serviceCount > 0) ? false : true;
    }
  }

  pushRepairData(){
    var res = 
    {
      "ServiceDetailId":0,
      "ServiceId":"0",
      "ElementType":"ExRepair",
      "ServiceName":this.translate.instant('Common.CommonText.label.AddReapirComment'),
      "Quantity":0,
      "duration":120,
      "LineAmountVat":0,
      "VM":0,
      "Rebate":0,
      "ApplicablePrice":0,
      "TotalRegularPrice":0,
      "groupId":null,
      "RepairComment":this.RepairComment,
      "Parts":null,
      "Labour":null   
    }
  
    this.IsSubmitted =false    
    this.SelectedAdditionalService.push(res);
    this.AdditionalTotalDuration += res.duration;
    this.DurationTotal = this.AdditionalTotalDuration + this.PackageDuration + this.EUControlduration;
  }

  removeRepairItem(){
    const index = this.SelectedAdditionalService.findIndex( x => x.ElementType === 'ExRepair' );
    if (index !== -1) {
      this.AdditionalTotalDuration -= this.SelectedAdditionalService[index].duration;
      this.SelectedAdditionalService.splice(index, 1);   
      this.DurationTotal = this.AdditionalTotalDuration + this.PackageDuration + this.EUControlduration;
    }
  }

}
